/* eslint-disable import/no-mutable-exports */
import merge from 'lodash/fp/merge';
import memoize from 'lodash/memoize';
import { css } from 'styled-components';
import getReadibilityColor from '../utils/readibility';

export const K_WEIGHT_MEDIUM = '500';
export const K_WEIGHT_NORMAL = '400';
export const K_WEIGHT_LIGHT = '300';

let styles = {
  /**
   * align
   */
  flex: css`
    display: flex;
  `,
  flexWrap: css`
    display: flex;
    flex-wrap: wrap;
  `,
  flexMiddle: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  flexLeftLeft: css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  `,
  flexLeftMiddle: css`
    display: flex;
    align-items: flex-start;
    justify-content: center;
  `,
  flexLeftRight: css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  `,
  flexLeftBetween: css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  `,
  flexMiddleLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  flexMiddleRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  flexRightLeft: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start'
  },
  flexRightMiddle: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  flexRightRight: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  /**
   * flex
   */
  flexDirCol: {
    display: 'flex',
    flexDirection: 'column'
  },
  flexDirRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  flex1: {
    flex: 1
  },
  flex2: {
    flex: 2
  },
  flex3: {
    flex: 3
  },
  flex4: {
    flex: 4
  },
  flex5: {
    flex: 5
  },

  /**
   * font weight
   */
  fwb: css`
    font-family: 'Avenir';
    font-weight: bold;
  `,
  fwm: css`
    font-family: 'Avenir';
    font-weight: 500;
  `,
  fwr: css`
    font-family: 'Avenir';
  `,
  fwl: css`
    font-family: 'Avenir';
    font-weight: lighter;
  `,

  pointer: css`
    cursor: pointer;
  `,

  h1: {
    fontSize: 48
  },

  h2: {
    fontSize: 32
  },

  h3: {
    fontSize: 24
  },

  title1: {
    fontSize: 20
  },

  title2: {
    fontSize: 16
  },

  title3: {
    fontSize: 14
  },

  title4: {
    fontSize: 12
  },

  st1: {
    fontSize: 10
  },

  /**
   * font decoration
   */
  underline: {
    textDecorationLine: 'underline'
  },

  italic: {
    fontStyle: 'italic'
  },
  /**
   * font colors
   */
  fcm: css`
    color: ${({ theme: { colors } }) => colors.dark.light};
  `,
  fcp: css`
    color: ${({ theme: { colors } }) => colors.primary.primary};
  `,
  /**
   * background colors
   */

  bglp: css`
    background-color: ${({ theme: { colors } }) => colors.light.primary};
    color: ${({ theme }) => getReadibilityColor(theme.colors.light.primary, theme)};
  `,
  bgpl: css`
    background-color: ${({ theme: { colors } }) => colors.primary.light};
    color: ${({ theme }) => getReadibilityColor(theme.colors.primary.light, theme)};
  `,
  bggp: css`
    background-color: ${({ theme: { colors } }) => colors.gray.primary};
    color: ${({ theme }) => getReadibilityColor(theme.colors.gray.primary, theme)};
  `,
  bggl: css`
    background-color: ${({ theme: { colors } }) => colors.gray.light};
    color: ${({ theme }) => getReadibilityColor(theme.colors.gray.light, theme)};
  `,

  /**
   * text alignment
   */
  tal: {
    textAlign: 'left'
  },
  tac: {
    textAlign: 'center'
  },
  taj: {
    textAlign: 'justify'
  },
  tar: {
    textAlign: 'right'
  },

  shadown: {
    shadowColor: '#333',
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowRadius: 0,
    shadowOpacity: 0,
    elevation: 0
  },
  shadows: {
    shadowColor: '#333',
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowRadius: 1,
    shadowOpacity: 0.0975,
    elevation: 1
  },
  shadowm: css`
    box-shadow: 0px 1px 5px rgba(0, 16, 17, 0.1), 0px 3px 4px rgba(0, 16, 17, 0.06),
      0px 2px 4px rgba(0, 16, 17, 0.07);
  `,
  shadowl: {
    shadowColor: '#333',
    shadowOffset: {
      width: 0.4,
      height: 1.6
    },
    shadowRadius: 5,
    shadowOpacity: 0.3,
    elevation: 4
  },

  /**
   * position
   */
  abs: {
    position: 'absolute'
  },
  rel: {
    position: 'relative'
  },
  fill: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  left: {
    left: 0
  },
  right: {
    right: 0
  },
  top: {
    top: 0
  },
  bottom: {
    bottom: 0
  },

  /**
   * rotate
   */
  rot0: {
    transform: [{ rotate: '0deg' }]
  },
  rot30: {
    transform: [{ rotate: '30deg' }]
  },
  rot60: {
    transform: [{ rotate: '60deg' }]
  },
  rot90: {
    transform: [{ rotate: '90deg' }]
  },

  /**
   * width
   */
  width100: {
    width: '100%'
  },
  width50: {
    width: '50%'
  },
  width25: {
    width: '25%'
  }
};

/*
>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  SPACING UTILITIES
>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
*/
/**
 * Used to adjust the default spacing between components
 * Use with great care!
 *
 * <type><direction><size> -impt
 *
 * m : margin;
 * p : padding;
 *
 * a = all
 * t = top
 * r = right
 * b = bottom
 * l = left
 * h = horizontal
 * v = vertical
 *
 * n    = none                       : 0px;
 * xs   = extra small                : 3px;
 * s    = small                      : 6px;
 * m    = medium                     : 12px;
 * l    = large                      : 16px;
 * xl   = extra large                : 20px;
 * xxl  = extra extra large          : 24px;
 * xxxl = extra extra extra large    : 32px;

 * ptxs, pts, ptm, ptl, ptxl, plxs, pls, dst..
 * mtxs, mts, mtm, mtl, mtxl, mlxs, mls, mlm, dst..
 */

const K_NONE_SIZE = 0;
const K_EXTRA_EXTRA_SMALL_SIZE = 6;
const K_EXTRA_SMALL_SIZE = 8;
const K_SMALL_SIZE = 12;
const K_MEDIUM_SIZE = 16;
const K_LARGE_SIZE = 24;
const K_EXTRA_LARGE_SIZE = 30;
const K_EXTRA_EXTRA_LARGE_SIZE = 50;
const K_EXTRA_EXTRA_EXTRA_LARGE_SIZE = 64;

const K_BORDER_EXTRA_SMALL_SIZE = 0.3;
const K_BORDER_SMALL_SIZE = 0.5;
const K_BORDER_MEDIUM_SIZE = 1;
const K_BORDER_LARGE_SIZE = 1.5;
const K_BORDER_EXTRA_LARGE_SIZE = 1.8;

export const borderWithStylesData = {
  prefixKey: 'bw', // border width
  midKey: ['t', 'l', 'r', 'b', 'v', 'h', 'a'],
  postfixKey: ['n', 'xs', 's', 'm', 'l', 'xl'],
  value: [
    K_NONE_SIZE,
    K_BORDER_EXTRA_SMALL_SIZE,
    K_BORDER_SMALL_SIZE,
    K_BORDER_MEDIUM_SIZE,
    K_BORDER_LARGE_SIZE,
    K_BORDER_EXTRA_LARGE_SIZE
  ],
  prefixStyle: 'border',
  postfixStyle: [
    'TopWidth',
    'LeftWidth',
    'RightWidth',
    'BottomWidth',
    ['TopWidth', 'BottomWidth'],
    ['LeftWidth', 'RightWidth'],
    ['LeftWidth', 'TopWidth', 'BottomWidth', 'RightWidth']
  ]
};

const generateStyleData = [
  {
    prefixKey: 'p', // padding
    midKey: ['t', 'l', 'r', 'b', 'v', 'h', 'a'],
    postfixKey: ['n', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'],
    value: [
      K_NONE_SIZE,
      K_EXTRA_EXTRA_SMALL_SIZE,
      K_EXTRA_SMALL_SIZE,
      K_SMALL_SIZE,
      K_MEDIUM_SIZE,
      K_LARGE_SIZE,
      K_EXTRA_LARGE_SIZE,
      K_EXTRA_EXTRA_LARGE_SIZE,
      K_EXTRA_EXTRA_EXTRA_LARGE_SIZE
    ],
    prefixStyle: 'padding',
    postfixStyle: [
      'Top',
      'Left',
      'Right',
      'Bottom',
      ['Top', 'Bottom'],
      ['Left', 'Right'],
      ['Left', 'Top', 'Bottom', 'Right']
    ]
  },
  {
    prefixKey: 'br', // borderRadius
    midKey: ['', 'a', 't', 'b', 'l', 'lt', 'lb', 'r', 'rt', 'rb'],
    postfixKey: ['n', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'],
    value: [0, 2, 4, 6, 8, 10, 12, 14],
    prefixStyle: 'border',
    postfixStyle: [
      'Radius',
      'Radius',
      ['TopLeftRadius', 'TopRightRadius'],
      ['BottomRightRadius', 'BottomLeftRadius'],
      ['TopLeftRadius', 'BottomLeftRadius'],
      'TopLeftRadius',
      'BottomLeftRadius',
      ['TopRightRadius', 'BottomRightRadius'],
      'TopRightRadius',
      'BottomRightRadius'
    ]
  },
  {
    prefixKey: 'm', // margin
    midKey: ['t', 'l', 'r', 'b', 'v', 'h', 'a'],
    postfixKey: ['n', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'],
    value: [
      K_NONE_SIZE,
      K_EXTRA_EXTRA_SMALL_SIZE,
      K_EXTRA_SMALL_SIZE,
      K_SMALL_SIZE,
      K_MEDIUM_SIZE,
      K_LARGE_SIZE,
      K_EXTRA_LARGE_SIZE,
      K_EXTRA_EXTRA_LARGE_SIZE,
      K_EXTRA_EXTRA_EXTRA_LARGE_SIZE
    ],
    prefixStyle: 'margin',
    postfixStyle: [
      'Top',
      'Left',
      'Right',
      'Bottom',
      ['Top', 'Bottom'],
      ['Left', 'Right'],
      ['Left', 'Top', 'Bottom', 'Right']
    ]
  },
  borderWithStylesData
];

export const generateStyle = memoize((serialize, _s, styleData) => {
  let s = Object.assign({}, _s);
  styleData.forEach(currentStyle => {
    currentStyle.midKey.forEach((currMidKey, idxMidKey) => {
      currentStyle.postfixKey.forEach((currPostfixKey, idxPostfixKey) => {
        const key = `${currentStyle.prefixKey}${currMidKey}${currPostfixKey}`;
        const value = currentStyle.value[idxPostfixKey];

        const currPostfixStyles = currentStyle.postfixStyle[idxMidKey];

        const postfixStyles =
          currPostfixStyles instanceof Array ? currPostfixStyles : [currPostfixStyles];

        postfixStyles.forEach(currPostfixStyle => {
          const styleKey = `${currentStyle.prefixStyle}${currPostfixStyle}`;
          const newValue = {
            [key]: {
              [styleKey]: value
            }
          };
          const newStyle = serialize
            ? serialize(newValue, key, {
                [styleKey]: value
              })
            : newValue;
          s = merge(s, newStyle);
        });
      });
    });
  });
  return s;
});

styles = generateStyle(undefined, styles, generateStyleData);

export default styles as any;
